export default __webpack_public_path__ + "3fffb652aa2404314d6da030c111b1d9.jpg";